import React from 'react';
import { Link } from 'react-router-dom';
import { TableHeading, TableRow } from '../../../models/interfaces/Table';
import { ThomasAdvertiser } from '../../../models/interfaces/index';
import { CONSTANTS } from '@tpco/tpco-saturn-types';
import { SortOptions } from 'models/interfaces/PageCache';

const makeAdvertiserHeadings = (sortOptions: SortOptions) => {
  const { name, tgrams_id, thomasCampaigns } = sortOptions;

  const advertiserHeadings: TableHeading[] = [
    {
      key: 'name',
      value: 'Company Name',
      style: 'sortable',
      sort: true,
      direction: name
    },
    {
      key: 'tgrams_id',
      value: 'Company ID',
      style: 'sortable align-right',
      sort: true,
      direction: tgrams_id
    },
    {
      key: 'campaigns',
      value: 'Campaigns',
      style: 'sortable align-right',
      sort: true,
      direction: thomasCampaigns
    },
    {
      key: 'details',
      value: 'Details',
      style: 'align-center'
    }
  ];
  return advertiserHeadings;
};

const makeAdvertiserByProductHeadings = (sortOptions: SortOptions) => {
  const { name, tgrams_id, campaigns } = sortOptions;

  const advertiserHeadings: TableHeading[] = [
    {
      key: 'name',
      value: 'Company Name',
      style: 'sortable',
      sort: true,
      direction: name
    },
    {
      key: 'tgrams_id',
      value: 'Company ID',
      style: 'sortable align-right',
      sort: true,
      direction: tgrams_id
    },
    {
      key: 'campaigns',
      value: 'Campaigns',
      style: 'sortable align-right',
      sort: true,
      direction: campaigns
    },
    {
      key: 'details',
      value: 'Details',
      style: 'align-center'
    }
  ];
  return advertiserHeadings;
};

const createAdvertiserRow = (thomasAdvertiser: ThomasAdvertiser) => {
  const advertiserRow: TableRow = { ...thomasAdvertiser };
  advertiserRow.name = (
    <Link to={`/advertisers/${thomasAdvertiser.tgrams_id}`}>
      <span className="thomas-advertisers__advertiser-name">{thomasAdvertiser.name}</span>
    </Link>
  );
  advertiserRow.details = (
    <Link to={`/advertisers/${thomasAdvertiser.tgrams_id}`}>
      <button className="btn btn-outline-secondary">view</button>
    </Link>
  );

  return advertiserRow;
};

const createAdvertiserByProductRow = (thomasAdvertiser: ThomasAdvertiser, productId: number) => {
  const advertiserRow: TableRow = { ...thomasAdvertiser };
  advertiserRow.name = (
    <Link to={`/advertisers/${thomasAdvertiser.tgrams_id}/products/${productId}`}>
      <span className="thomas-advertisers__advertiser-name">{thomasAdvertiser.name}</span>
    </Link>
  );
  advertiserRow.details = (
    <Link to={`/advertisers/${thomasAdvertiser.tgrams_id}/products/${productId}`}>
      <button className="btn btn-outline-secondary">view</button>
    </Link>
  );
  return advertiserRow;
};

const createAdvertiserRows = (thomasAdvertisers: ThomasAdvertiser[], productId: number) => {
  return thomasAdvertisers.map((thomasAdvertiser: ThomasAdvertiser) =>
    productId
      ? createAdvertiserByProductRow(thomasAdvertiser, productId)
      : createAdvertiserRow(thomasAdvertiser)
  );
};

export {
  makeAdvertiserHeadings,
  createAdvertiserRows,
  createAdvertiserRow,
  createAdvertiserByProductRow,
  makeAdvertiserByProductHeadings
};
